import { isSameDay } from '@sequencehq/utils/dates'
import {
  CubeReducerState,
  ResolvedPhase
} from 'modules/Cube/domain/cube.domain.types'

/**
 * The phase the amendment takes effect in, which is the one starting on the
 * effective from date. Phases carry no amendment flag, and the user can rename
 * this one, so the date is the only reliable way to find it.
 */
export const getAmendmentPhaseId =
  (ctx: { orderedPhases: Pick<ResolvedPhase, 'id' | 'dates'>[] }) =>
  (
    prevState: Pick<CubeReducerState, 'data'>
  ): ResolvedPhase['id'] | undefined => {
    const effectiveFrom = prevState.data.quote.amendment?.effectiveFrom

    if (prevState.data.quote.dealType !== 'AMENDMENT' || !effectiveFrom) {
      return
    }

    return ctx.orderedPhases.find(phase => {
      const phaseStartDate = phase.dates.absolute.start

      return phaseStartDate && isSameDay(phaseStartDate, effectiveFrom)
    })?.id
  }
